'use strict'

import Vue from 'vue'
import axios from 'axios'

// Point to development environment
// let apiKey = 'J1DWJi6L4710H5opgtgFo40fqQhQTMgwITmOAdPFmj5V70E52cDg478DSdrTy10R'
// let apiRoot = 'https://api.haitipay.com/v1-dev'

let apiKey = 'J1DWJi6L4710H5opgtgFo40fqQhQTMgwITmOAdPFmj5V70E52cDg478DSdrTy10R'
let apiRoot = 'https://api.haitipay.com/v1'

let userId = localStorage.getItem('userId')
let authToken = localStorage.getItem('authToken')

const accountService = new Vue()

const register = (payload) => {
  let url = `${apiRoot}/accounts`
  return axios.post(url, payload, {
    headers: {
      authorization: apiKey
    }
  })
}

const login = (credentials) => {
  let url = `${apiRoot}/accounts/login`
  return axios.post(url, credentials, {
    headers: {
      authorization: apiKey
    }
  })
}

const HTTP = axios.create({
  baseURL: apiRoot,
  headers: {
    authorization: apiKey
  }
})

function account(userId, authToken) {
  let url = `/accounts/${userId}?access_token=${authToken}`
  return HTTP
    .get(url)
    .then(response => response.data)
}

export {
  register,
  userId,
  authToken,
  login,
  HTTP,
  account,
  accountService
}



// WEBPACK FOOTER //
// ./src/services/account-services.js